import React from 'react';

class PayPalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Silently handle expected Braintree/PayPal configuration errors
    if (error && error.message && (
        error.message.includes('assetsUrl') || 
        error.message.includes('PAYPAL_NOT_ENABLED') ||
        error.message.includes('Cannot read properties of undefined')
    )) {
      // Debug log only, to verify it's working but not alarm the user
      // console.debug('PayPal button hidden due to configuration mismatch:', error.message);
    } else {
      // Log genuine unexpected errors
      console.error('PayPalErrorBoundary caught an unexpected error:', error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}

export default PayPalErrorBoundary;
